import axios from "axios";

const apiUrl = process.env.REACT_APP_BASE_URL;
// const apiUrl = "http://localhost:3001/api";

const axiosInstance = axios.create({
  baseURL: apiUrl,
});

export const logoutEvent = new Event("userLogout");

export const logout = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  window.dispatchEvent(logoutEvent);
  window.location.href = "/login";
};

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem("refreshToken");

        if (!refreshToken) {
          console.error("No refresh token available");
          logout();
          return Promise.reject(error);
        }

        const response = await axios.post(`${apiUrl}/user/refresh-token`, {
          refreshToken,
        });

        const { accessToken } = response.data;

        if (!accessToken) {
          console.error("Failed to get new access token");
          logout();
          return Promise.reject(error);
        }

        localStorage.setItem("accessToken", accessToken);

        originalRequest.headers["Authorization"] = `Bearer ${accessToken}`;
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        console.error("Token refresh failed:", refreshError);

        logout();
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
